export default "__VITE_ASSET__9PG2wTb1__"